module.exports = __webpack_public_path__ + "img/1.bd46badd.jpg";